const handleFetchEmpContractsFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.empContracts = action.payload.data;
};
const handleFetchContractDetailssFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.contractDetails = action.payload.data;
};
const handleFetchContractsFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.contracts = action.payload.data;
  state.currentPage = action.payload.current_page;
  state.perPage = action.payload.limit;
  state.totalPages = action.payload.total_pages;
  state.total = action.payload.total_count;
  state.lastUpdated = action.payload.last_updated;
};
export {
  handleFetchEmpContractsFulfilled,
  handleFetchContractDetailssFulfilled,
  handleFetchContractsFulfilled
};